﻿import React, {Component} from 'react';
import { browserHistory } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import { renderSelectField, renderSwitchField, renderTextField } from '../../components/core/editors';
import { connect } from 'react-redux';
import NavigationBack from 'material-ui/svg-icons/navigation/arrow-back';
import {Paper, Dialog, FlatButton, MenuItem, Subheader, IconButton, AppBar, CircularProgress, LinearProgress, RaisedButton} from 'material-ui';
import service from '../../services/feed-source-services';

class FeedSourceDetails extends Component {
    constructor(props, context) {
        super(props, context);

        this.onBackToList = this.onBackToList.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.onDeleteConfirm = this.onDeleteConfirm.bind(this);
        this.handleDeleteClose = this.handleDeleteClose.bind(this);
        this.deleteConfirmed = this.deleteConfirmed.bind(this);

        this.feedSourceId = context.router.params.feedSourceId;
    }

    componentDidMount() {
        this.props.onGetFeedSource(this.feedSourceId);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    submitForm(data) {
        this.props.onSubmitFeedSource(data);
    }

    onDeleteConfirm() {
        this.props.onConfirmDeleteFeedSource(true);
    }

    handleDeleteClose() {
        this.props.onConfirmDeleteFeedSource(false);
    }

    deleteConfirmed() {
        this.props.onDeleteFeedSource(this.feedSourceId);
    }

    onBackToList() {
        browserHistory.goBack();
    }

    render() {

        const { handleSubmit, pristine, submitting, inProgress, saving, openDeleteDialog } = this.props;

        if (inProgress) {
            return (
                <div>
                    <AppBar title="Feed Source editor"
                            iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack /></IconButton>}
                            iconElementRight={<FlatButton label="Save" type="submit" disabled={pristine || submitting}/>}
                    />
                    <div style={{margin: 100}}>
                        <CircularProgress size={100} thickness={5}/>
                    </div>
                </div>
            )
        }

        const deleteActions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.handleDeleteClose}
            />,
            <FlatButton
                label="Delete"
                secondary={true}
                keyboardFocused={true}
                onTouchTap={this.deleteConfirmed}
            />,
        ];

        return (
            <div>
                <form onSubmit={handleSubmit(this.submitForm)} noValidate={true} >
                    <AppBar title="Feed Source editor"
                            iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack /></IconButton>}
                            iconElementRight={<FlatButton label="Save" type="submit" />}
                    />

                    <Paper className="template-edit-form" zDepth={1}>
                        { saving ? <LinearProgress mode="indeterminate"/> : null }

                        <Field name="Id" type="hidden" component={renderTextField} label="Id"  />
                        <Field required name="FeedType" component={renderSelectField} label="Feed Type" tooltip={<span>Feed Type</span>}>
                            <MenuItem value={0} primaryText="Facebook"/>
                            <MenuItem value={1} primaryText="Twitter"/>
                            <MenuItem value={2} primaryText="Broadcastify"/>
                        </Field>
                        <Field required name="SourceId" component={renderTextField} label="Feed Source Id" tooltip="Feed Source Id" />
                        <Field required name="Name" component={renderTextField} label="Feed Source Name" tooltip="Human readable source name" />
                        <Field required name="Link" component={renderTextField} label="Feed Link" tooltip="Feed Link" />
                        <Field required name="MinListeners" component={renderTextField} label="Min Listeners" tooltip="Min Listeners (Used for Broadcastify)" />


                        <RaisedButton label="Delete" secondary={true} onClick={this.onDeleteConfirm} style={{
                            margin: "auto",
                            marginTop: "50px",
                            marginBottom: "50px",
                            display: this.feedSourceId > 0 ? "block" : "none",
                            width: "150px"
                        }} />

                    </Paper>
                </form>

                <Dialog
                    title="Delete Feed Source?"
                    actions={deleteActions}
                    modal={false}
                    open={openDeleteDialog == undefined ? false : openDeleteDialog}
                    onRequestClose={this.handleDeleteClose}
                >
                    Are you sure you want to delete Feed Source?
                </Dialog>
            </div>
        );
    }
}

const validate = values => {
    const errors = {};
    const requiredFields = [ 'SourceId', 'FeedType' ];
    requiredFields.forEach(field => {
        if (!values[ field ] && values[field] !== 0) {
            errors[ field ] = 'Required';
        }
    });
    if (isNaN(Number(values.MinListeners))) {
        errors.MinListeners = 'Must be a number'
    } else if (Number(values.MinListeners) < 0) {
        errors.MinListeners = 'Sorry, value must be positive'
    }
    return errors;
};

const mapStateToProps = state => ({...state.feedSources});

const mapDispatchToProps = dispatch => ({
    onGetFeedSource: (id) =>
        dispatch({type: 'REQUEST_FEED_SOURCE', payload: id > 0 ? service.FeedSourceServices.getFeedSource(id) : {
            FeedType: 0,
            MinListeners: 0
        }}),
    onSubmitFeedSource: (feedSource) =>
        dispatch({type: 'SUBMIT_FEED_SOURCE', payload: service.FeedSourceServices.postFeedSource(feedSource)}),
    onConfirmDeleteFeedSource: (open) =>
        dispatch({type: 'CONFIRM_DELETE_FEED_SOURCE', payload: open}),
    onDeleteFeedSource: (id) =>
        dispatch({type: 'DELETE_FEED_SOURCE', payload: service.FeedSourceServices.deleteFeedSource(id)}),
    onUnload: () =>
        dispatch({type: 'FEED_SOURCES_PAGE_UNLOADED'})
});

FeedSourceDetails.contextTypes = {
    router: React.PropTypes.any.isRequired
};

FeedSourceDetails = reduxForm({
    form: 'feedSourceForm',
    enableReinitialize: true,
    validate
})(FeedSourceDetails);

FeedSourceDetails = connect(mapStateToProps, mapDispatchToProps)(FeedSourceDetails);

export default FeedSourceDetails;